import * as RoutePathConstants from '../../../../constants/RoutePathConstants'
import pointsMailCashier from './views/points-mail-cashier'

export default [
  {
    path: RoutePathConstants.POINTS_MAIL_CASHIER,
    name: 'pointsMailCashier',
    component: pointsMailCashier
  }
]



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-cashier/routers.js